import { render, staticRenderFns } from "./DetalhesFrentista.vue?vue&type=template&id=dbe9e408&"
import script from "./DetalhesFrentista.vue?vue&type=script&lang=js&"
export * from "./DetalhesFrentista.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports